module.exports = __webpack_public_path__ + "static/media/pomerode-alimentos.92fde39f.jpeg";